<template>
  <div class="col-12 mt-2">
    <form>
      <input
        :placeholder="placeholder || 'Từ khóa'"
        v-model="keyword"
        type="text"
        @keyup="onEnter($event)"
        @change="change()">
      <button
        type="button"
        @click="onSearch()">Tìm kiếm
      </button>
    </form>
  </div>
</template>

<script>
    export default {
        name: "SearchInput",
        props: ["placeholder"],
        data() {
            return {
                keyword: ''
            }
        },
        methods: {
            change() {
                this.$emit('change', this.keyword);
            },
            onSearch() {
                this.$emit('onSearch', this.keyword);
            },
            onEnter(event) {
                if (event.which !== 13) {
                    return;
                }
                event.target.blur();
                this.onSearch();
            }
        }
    }
</script>

<style lang="scss" scoped>
  .mobile-menu {
      button {
        float: right;
        padding: 5px;
        background: #ddd;
        font-size: 14px;
        border: none;
        cursor: pointer;
        width: 20%;
        height: 36px;
        line-height: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      button:hover {
        background: #ccc;
      }

      input {
        height: 36px;
        line-height: 36px;
        width: 80%;
        border: none;
        padding-left: 10px;
      }

      button:focus, input:focus{
        outline: none;
        padding-left: 10px;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/SearchInput.vue